"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linktree = void 0;
var types_1 = require("../types");
exports.linktree = {
    name: 'linktree',
    matches: [
        {
            match: '(https?://)?(www.)?linktr.ee/({PROFILE_ID})/?', group: 3, type: types_1.TYPE_DESKTOP,
            pattern: 'https://linktr.ee/{PROFILE_ID}'
        },
        { match: '({PROFILE_ID})', group: 1 },
    ]
};
